var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal && _vm.loadedItem
    ? _c("div", { staticClass: "quick-view__wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal fade quick-view__modal",
            attrs: { tabindex: "-1", role: "dialog" },
            on: {
              click: function($event) {
                return _vm.closeQuickView($event.target)
              }
            }
          },
          [
            _c("div", { staticClass: "modal-dialog" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-body" }, [
                  _c(
                    "div",
                    {
                      staticClass: "quick-view__close",
                      on: {
                        click: function($event) {
                          return _vm.closeQuickView()
                        }
                      }
                    },
                    [
                      _c("svg", { attrs: { width: "18", height: "18" } }, [
                        _c("use", {
                          attrs: {
                            "xlink:href": "#svg_close-basketmodal",
                            "xmlns:xlink": "https://www.w3.org/1999/xlink"
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-7" },
                      [
                        _c("item-image-carousel", {
                          attrs: {
                            "item-data": _vm.currentVariation,
                            "plugin-path": _vm.pluginPathCeres,
                            "image-url-accessor": "url"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-5" }, [
                      _c(
                        "div",
                        { staticClass: "quick-view__right-side" },
                        [
                          _c("div", { staticClass: "quick-view__name" }, [
                            _vm._v(
                              _vm._s(_vm._f("itemName")(_vm.currentVariation))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "quick-view__price" }, [
                            _vm.currentVariation.prices.rrp &&
                            _vm.currentVariation.prices.rrp.price.value > 0 &&
                            _vm.currentVariation.prices.rrp.price.value >
                              _vm.currentVariation.prices.default.unitPrice
                                .value
                              ? _c(
                                  "span",
                                  { staticClass: "crossprice-cat-rebate mr-2" },
                                  [
                                    _vm.currentVariation.prices.specialOffer
                                      ? _c(
                                          "del",
                                          { staticClass: "crossprice" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm._f("itemCrossPrice")(
                                                    _vm.currentVariation.prices
                                                      .default.unitPrice
                                                      .formatted,
                                                    true
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "del",
                                          { staticClass: "crossprice" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.currentVariation.prices
                                                    .rrp.unitPrice.formatted
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "price" }, [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(
                                    _vm._f("specialOffer")(
                                      _vm.currentVariation.prices.default
                                        .unitPrice.formatted,
                                      _vm.currentVariation.prices,
                                      "unitPrice",
                                      "formatted"
                                    )
                                  ) +
                                  "\n                                    "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "vat small" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.$translate(
                                    "Froschkoenig::Template.singleVat1"
                                  )
                                ) +
                                " " +
                                _vm._s(
                                  _vm.$translate(
                                    "Froschkoenig::Template.singleVat2"
                                  )
                                ) +
                                "\n                                "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.currentVariation.variation.bundleType === "bundle"
                            ? _c("item-bundle", {
                                attrs: {
                                  "bundle-type":
                                    _vm.currentVariation.variation.bundleType,
                                  "bundle-components":
                                    _vm.currentVariation.bundleComponents
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _vm.currentVariation.stock.net > 0
                            ? _c("p", { staticClass: "single__stock" }, [
                                _vm.currentVariation.stock.net > 10
                                  ? _c("span", [
                                      _c("div", {
                                        staticClass:
                                          "stock-indicator stock-indicator-green"
                                      }),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.singleStockMoreThan10"
                                            )
                                          ) +
                                          "\n                                    "
                                      )
                                    ])
                                  : _c("span", [
                                      _c("div", {
                                        staticClass:
                                          "stock-indicator stock-indicator-red"
                                      }),
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.singleStockOnly1"
                                            )
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.currentVariation.stock.net
                                          ) +
                                          " " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.singleStockOnly2"
                                            )
                                          ) +
                                          "\n                                    "
                                      )
                                    ])
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "table",
                            { staticClass: "table single__details-table" },
                            [
                              _c("tbody", [
                                _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "single__td-label" },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemNumber"
                                            )
                                          ) +
                                          "\n                                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(_vm.currentVariation.item.id))
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "single__td-label" },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemDimensions"
                                            )
                                          ) +
                                          "\n                                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("td", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.item.free9
                                      )
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "single__td-label" },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Froschkoenig::Template.singleItemLieferzeit"
                                            )
                                          ) +
                                          "\n                                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    {
                                      class:
                                        "single__availability-label-" +
                                        _vm.currentVariation.variation
                                          .availability.id
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            " +
                                          _vm._s(
                                            _vm.currentVariation.variation
                                              .availability.names.name
                                          ) +
                                          "\n                                        "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  { staticClass: "hidden toggle-hidden" },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "single__td-label" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Froschkoenig::Template.singleShippingInfo"
                                              )
                                            ) +
                                            "\n                                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            "data-toggle": "modal",
                                            href: "#shippingscosts"
                                          },
                                          on: {
                                            "~mouseover": function($event) {
                                              return _vm.$store.dispatch(
                                                "loadComponent",
                                                "shippingscosts-modal"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Froschkoenig::Template.singleShippingInfoShow"
                                                )
                                              ) +
                                              "\n                                            "
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.currentVariation.variation.weightG > 0
                                  ? _c(
                                      "tr",
                                      { staticClass: "hidden toggle-hidden" },
                                      [
                                        _c(
                                          "td",
                                          { staticClass: "single__td-label" },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Froschkoenig::Template.singleShippingWeight"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.variation
                                                .weightG / 1000
                                            ) + " kg"
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  { staticClass: "hidden toggle-hidden" },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "single__td-label" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Froschkoenig::Template.singleShippingCondition"
                                              )
                                            ) +
                                            "\n                                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.currentVariation.item.free6
                                        )
                                      }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "tr",
                                  { staticClass: "hidden toggle-hidden" },
                                  [
                                    _c(
                                      "td",
                                      { staticClass: "single__td-label" },
                                      [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm.$translate(
                                                "Froschkoenig::Template.singleShippingInfoDetails"
                                              )
                                            ) +
                                            "\n                                        "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("td", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.currentVariation.item.free5
                                        )
                                      }
                                    })
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.hasPaketOrSpeditionProp
                            ? [
                                _vm.has304Prop
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "shippinginfo-link",
                                          attrs: {
                                            "data-toggle": "modal",
                                            href: "#shippinginfo-304"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.injectPricesIntoModal()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xmlns:xlink":
                                                    "http://www.w3.org/1999/xlink",
                                                  "xlink:href":
                                                    "#spedition-no-text"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Froschkoenig::Template.shippinginfoMontage"
                                                )
                                              ) +
                                              "\n                                            "
                                          ),
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "svg-icon__icon",
                                              attrs: {
                                                role: "img",
                                                focusable: "false",
                                                viewBox: "0 0 22 22",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "shippinginfo-link",
                                          attrs: {
                                            "data-toggle": "modal",
                                            href: "#shippinginfo-302"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.injectPricesIntoModal()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "svg",
                                            {
                                              attrs: {
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c("use", {
                                                attrs: {
                                                  "xmlns:xlink":
                                                    "http://www.w3.org/1999/xlink",
                                                  "xlink:href":
                                                    "#spedition-no-text"
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Froschkoenig::Template.shippinginfoSpedNoMontage"
                                                )
                                              ) +
                                              "\n                                            "
                                          ),
                                          _c(
                                            "svg",
                                            {
                                              staticClass: "svg-icon__icon",
                                              attrs: {
                                                role: "img",
                                                focusable: "false",
                                                viewBox: "0 0 22 22",
                                                xmlns:
                                                  "http://www.w3.org/2000/svg"
                                              }
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("path", {
                                                attrs: {
                                                  d:
                                                    "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                              ]
                            : [
                                _vm._l(_vm.varProps, function(prop) {
                                  return [
                                    prop.values.selectionId == 302 ||
                                    prop.values.selectionId == 303
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "shippinginfo-link",
                                              attrs: {
                                                "data-toggle": "modal",
                                                href: _vm.hasShippingPrices
                                                  ? "#shippinginfo-302-prices"
                                                  : "#shippinginfo-302"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.injectPricesIntoModal()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      "xmlns:xlink":
                                                        "http://www.w3.org/1999/xlink",
                                                      "xlink:href":
                                                        "#spedition-no-text"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.hasShippingPrices
                                                ? [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Froschkoenig::Template.shippinginfoSpedMontage"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Froschkoenig::Template.shippinginfoSpedNoMontage"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "svg",
                                                {
                                                  staticClass: "svg-icon__icon",
                                                  attrs: {
                                                    role: "img",
                                                    focusable: "false",
                                                    viewBox: "0 0 22 22",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      : prop.values.selectionId == 301
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "shippinginfo-link",
                                              attrs: {
                                                "data-toggle": "modal",
                                                href: _vm.hasShippingPrices
                                                  ? "#shippinginfo-301-prices"
                                                  : "#shippinginfo-301"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.injectPricesIntoModal()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      "xmlns:xlink":
                                                        "http://www.w3.org/1999/xlink",
                                                      "xlink:href":
                                                        "#spedition-no-text"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.hasShippingPrices
                                                ? [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Froschkoenig::Template.shippinginfoPaketMontage"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      "\n                                                    " +
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "Froschkoenig::Template.shippinginfoPaketNoMontage"
                                                          )
                                                        ) +
                                                        "\n                                                "
                                                    )
                                                  ],
                                              _vm._v(" "),
                                              _c(
                                                "svg",
                                                {
                                                  staticClass: "svg-icon__icon",
                                                  attrs: {
                                                    role: "img",
                                                    focusable: "false",
                                                    viewBox: "0 0 22 22",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ],
                                            2
                                          )
                                        ]
                                      : prop.values.selectionId == 304
                                      ? [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "shippinginfo-link",
                                              attrs: {
                                                "data-toggle": "modal",
                                                href: "#shippinginfo-304"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.injectPricesIntoModal()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c("use", {
                                                    attrs: {
                                                      "xmlns:xlink":
                                                        "http://www.w3.org/1999/xlink",
                                                      "xlink:href":
                                                        "#spedition-no-text"
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Froschkoenig::Template.shippinginfoMontage"
                                                    )
                                                  ) +
                                                  "\n                                                "
                                              ),
                                              _c(
                                                "svg",
                                                {
                                                  staticClass: "svg-icon__icon",
                                                  attrs: {
                                                    role: "img",
                                                    focusable: "false",
                                                    viewBox: "0 0 22 22",
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg"
                                                  }
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d:
                                                        "M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z"
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      : _vm._e()
                                  ]
                                })
                              ],
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticClass: "single__more-details",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.toggleHiddenRows()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                        " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Froschkoenig::Template.singleMoreInfo"
                                      )
                                    ) +
                                    "\n                                        "
                                ),
                                _c("i", {
                                  staticClass:
                                    "fa fa-chevron-down single__more-info-icon"
                                })
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-9" },
                              [
                                _c("variation-select", {
                                  attrs: { "item-data": _vm.currentVariation }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _vm.crossseller.length > 0
                            ? _c(
                                "div",
                                { staticClass: "quick-view__crossseller" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 col-lg-12 single__variation-selection--variations"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "single__variation-selection--headline"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "Froschkoenig::Template.moreVariations"
                                                )
                                              ) +
                                              ":\n                                        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "similar__flex" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "swiper-container single-variations-swiper"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "swiper-wrapper"
                                                },
                                                _vm._l(
                                                  _vm.crossseller,
                                                  function(cross) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "swiper-slide"
                                                      },
                                                      [
                                                        _c(
                                                          "category-item",
                                                          {
                                                            key:
                                                              cross.data.item
                                                                .id,
                                                            attrs: {
                                                              "item-data":
                                                                cross.data,
                                                              firstimagefull:
                                                                cross.data
                                                                  .images
                                                                  .firstImage
                                                                  .url,
                                                              "decimal-count": 0,
                                                              size: "small",
                                                              firstimage:
                                                                cross.data
                                                                  .images
                                                                  .firstImage
                                                                  .urlPreview
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "a",
                                                              {
                                                                staticClass:
                                                                  "small",
                                                                attrs: {
                                                                  href: _vm._f(
                                                                    "itemURL"
                                                                  )(cross.data)
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fa fa-image"
                                                                }),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "d-none"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                                    " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "itemName"
                                                                          )(
                                                                            cross.data
                                                                          )
                                                                        ) +
                                                                        "\n                                                                "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                0
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "swiper-button-prev swiper-button-prev-variations swiper-button-black"
                                            },
                                            [_vm._v(" ")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "swiper-button-next swiper-button-next-variations swiper-button-black"
                                            },
                                            [_vm._v(" ")]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.crossseller.length > 0 ||
                          _vm.attributesToCheck.length > 0
                            ? _c("hr")
                            : _vm._e(),
                          _vm._v(" "),
                          _c("add-to-basket", {
                            attrs: {
                              "variation-id": _vm.currentVariation.variation.id,
                              "is-salable":
                                !!_vm.currentVariation.filter &&
                                _vm.currentVariation.filter.isSalable,
                              "has-children":
                                !!_vm.currentVariation.filter &&
                                _vm.currentVariation.filter.hasActiveChildren,
                              "interval-quantity":
                                _vm.currentVariation.variation
                                  .intervalOrderQuantity || 1,
                              "minimum-quantity":
                                _vm.currentVariation.variation
                                  .minimumOrderQuantity,
                              "maximum-quantity":
                                !!_vm.currentVariation.variation
                                  .maximumOrderQuantity &&
                                _vm.currentVariation.variation
                                  .maximumOrderQuantity > 0
                                  ? _vm.currentVariation.variation
                                      .maximumOrderQuantity
                                  : null,
                              "order-properties": _vm.currentVariation.properties.filter(
                                function(prop) {
                                  return prop.property.isOderProperty
                                }
                              ),
                              "use-large-scale": false,
                              "show-quantity": true,
                              origin: "category",
                              "item-data": _vm.currentVariation,
                              "item-url": _vm._f("itemURL")(
                                _vm.currentVariation
                              ),
                              "is-variation-selected":
                                _vm.isVariationSelected &&
                                _vm.currentVariation.filter.isSalable,
                              "has-price": _vm._f("hasItemDefaultPrice")(
                                _vm.currentVariation
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-default w-100 mt-3",
                              attrs: {
                                href: _vm._f("itemURL")(_vm.currentVariation)
                              }
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Froschkoenig::Template.quickViewDetails"
                                    )
                                  ) +
                                  "\n                                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-none" }, [
                            _vm.currentVariation.item.free3 != "" &&
                            _vm.currentVariation.item.free3 != null
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "video-1 d-none",
                                    attrs: {
                                      target: "_blank",
                                      videoid: _vm.currentVariation.item.free3,
                                      href:
                                        "https://www.youtube.com/watch?v=" +
                                        _vm.currentVariation.item.free3
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-play" }),
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "Froschkoenig::Template.playVideo1"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentVariation.item.free14 != "" &&
                            _vm.currentVariation.item.free14 != null
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "video-2 d-none",
                                    attrs: {
                                      target: "_blank",
                                      videoid: _vm.currentVariation.item.free14,
                                      href:
                                        "https://www.youtube.com/watch?v=" +
                                        _vm.currentVariation.item.free14
                                    }
                                  },
                                  [
                                    _c("i", { staticClass: "fa fa-play" }),
                                    _vm._v(" "),
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$translate(
                                            "Froschkoenig::Template.playVideo2"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              : _vm._e()
                          ])
                        ],
                        2
                      )
                    ])
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }